import React from 'react';
import classNames from 'classnames';

function ButtonOption({
  asset,
  name,
  value,
  handleOptionOnMouse,
  handleOptionOnMouseLeave,
  handleChange,
  disabled,
  selected,
}) {
  const handleOnChangeOptions = () => {
    handleChange(value, asset);
  };

  const handleOptionOnMouseEnter = () => handleOptionOnMouse(name);

  return (
    <li className="list-inline-item mw-100">
      <button
        className={classNames('btn selector text mw-100 text-truncate', {
          selected: selected,
        })}
        aria-disabled={disabled}
        aria-label="floating"
        aria-pressed="false"
        onClick={handleOnChangeOptions}
        onMouseEnter={handleOptionOnMouseEnter}
        onMouseLeave={handleOptionOnMouseLeave}
        key={value}>
        <span>{name}</span>
      </button>
    </li>
  );
}

export default ButtonOption;
